export const FETCH_BATTERY_BEGAN = 'batteryById/FETCH_BATTERY_BEGAN'
export const FETCH_BATTERY_SUCCESS = 'batteryById/FETCH_BATTERY_SUCCESS'
export const FETCH_BATTERY_FAILED = 'batteryById/FETCH_BATTERY_FAILED'
export const REMOVE_BATTERY_FROM_USER_BEGAN = 'batteryById/REMOVE_BATTERY_FROM_USER_BEGAN'
export const REMOVE_BATTERY_FROM_USER_SUCCESS = 'batteryById/REMOVE_BATTERY_FROM_USER_SUCCESS'
export const REMOVE_BATTERY_FROM_USER_FAILED = 'batteryById/REMOVE_BATTERY_FROM_USER_FAILED'
export const REMOVE_BATTERY_FAILED = 'batteryById/REMOVE_BATTERY_FAILED'
export const REMOVE_BATTERY_SUCCESS = 'batteryById/REMOVE_BATTERY_SUCCESS'
export const REMOVE_BATTERY_BEGAN = 'batteryById/REMOVE_BATTERY_BEGAN'

